import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const Card = ({ title, icon, image, children }) => {
    return (
        <div className="flex justify-center items-center min-h-screen text-center w-full py-6">
            <div className="card_fade w-11/12 lg:w-1/2 bg-gray-900 bg-opacity-75 pb-10">
                <div className="w-full flex justify-end pr-6 pt-6">
                    <Link
                        to="/"
                        className="rounded-full p-3 hover:bg-white hover:bg-opacity-25 transition ease-in-out duration-300"
                    >
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            ></path>
                        </svg>
                    </Link>
                </div>

                <div className="px-8 lg:px-16">
                    <div className="flex justify-start">
                        <h2 className="text-2xl lg:text-2xl inline tracking-widest font-semibold border-b-2 pb-2">
                            {title}{' '}
                            <span role="img" aria-label="projects">
                                {icon}
                            </span>
                        </h2>
                    </div>
                    <div className="flex justify-center my-10">
                        <img
                            src={image}
                            alt="project"
                            className="w-full object-cover rounded-md"
                            style={{
                                maxHeight: '30vh',
                            }}
                        />
                    </div>

                    {children}
                </div>
            </div>
        </div>
    );
};

export default Card;
